var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconShapes = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-53.667 -343.667)" },
                React.createElement("g", { transform: "translate(-167 341)" },
                    React.createElement("g", { transform: "translate(221.75 3.75)" },
                        React.createElement("path", { d: "M6,4.3h11.8c0.9,0,1.7,0.8,1.7,1.7l0,0v11.8c0,0.9-0.8,1.7-1.7,1.7l0,0H6\n\t\t\t\t\tc-0.9,0-1.7-0.8-1.7-1.7l0,0V6C4.3,5,5,4.3,6,4.3L6,4.3z" }))),
                React.createElement("g", { transform: "translate(58.5 348.496)" },
                    React.createElement("path", { strokeWidth: "1.5", d: "M4.3,18.1c0,1,0.8,1.7,1.7,1.7h12.1c1,0,1.7-0.8,1.7-1.7l0,0V6c0-1-0.8-1.7-1.7-1.7l0,0" }))))));
});
export default IconShapes;
//# sourceMappingURL=IconShapes.js.map